import { Container } from '@backstage/ui';
import {
  CatalogFilterLayout,
  EntityListProvider,
  EntityOwnerPicker,
  EntityTagPicker,
  UserListPicker,
  type UserListFilterKind,
} from '@backstage/plugin-catalog-react';
import {
  EntityListDocsTable,
  TechDocsPicker,
} from '@backstage/plugin-techdocs';

/**
 * Content of the `/docs` index page on the new frontend system (PAT-1024).
 *
 * A copy of upstream's internal `TechDocsIndexPageContent`
 * (`@backstage/plugin-techdocs` 1.19.0, `dist/alpha/components/
 * TechDocsIndexPageContent.esm.js`), built from public exports. Upstream's
 * `page:techdocs` only takes `initialFilter` from static config, but the
 * persisted user-list filter (`PersistedUserListFilterPage`) must be re-read
 * on every mount, so the techdocs module renders this component with the
 * filter as a prop instead. Keep the composition in sync with upstream when
 * the plugin is upgraded.
 */
export const TechDocsIndexContent = ({
  initialFilter = 'owned',
}: {
  initialFilter?: UserListFilterKind;
}) => (
  <Container mt="6">
    <EntityListProvider>
      <CatalogFilterLayout>
        <CatalogFilterLayout.Filters>
          <TechDocsPicker />
          <UserListPicker initialFilter={initialFilter} />
          <EntityOwnerPicker />
          <EntityTagPicker />
        </CatalogFilterLayout.Filters>
        <CatalogFilterLayout.Content>
          <EntityListDocsTable />
        </CatalogFilterLayout.Content>
      </CatalogFilterLayout>
    </EntityListProvider>
  </Container>
);
